import React, { useState } from "react"
import { Grid, TextField, Chip } from "@material-ui/core"
import Autocomplete from "@material-ui/lab/Autocomplete"

import { renderComponent } from "@/utils/node"

import { ActionDialog } from "@/components"

import useStyles from "@/pages/Admin/ChatBot/ChatBotConstructor/Blocks/SaveInputBlock/InputLocationEditor/styles"

import { ChatBotFlowBlockContent } from "@/protocols/chatBot"
import { ConstructionResources } from "@/protocols/chatBotConstructor"

type ContactAlreadyExistsEditorProps = {
	onSave: (chatBotFlowBlockContent: ChatBotFlowBlockContent) => void
	constructionResources: ConstructionResources
	chatBotFlowBlockContent: ChatBotFlowBlockContent
}

type ContactAlreadyExistsEditorType = {
	open: (props: ContactAlreadyExistsEditorProps) => void
}

const ContactAlreadyExistsEditor: ContactAlreadyExistsEditorType & React.FC<ContactAlreadyExistsEditorProps> = (props) => {
	const {
		onSave,
		constructionResources,
		chatBotFlowBlockContent
	} = props

	const classes = useStyles()

	const [opened, setOpened] = useState(true)

	const [blockContent, setBlockContent] = useState<ChatBotFlowBlockContent>(chatBotFlowBlockContent)

	const handleClose = () => {
		setOpened(false)
	}

	const handleSave = async () => {
		onSave(blockContent)

		handleClose()
	}

	const handleChangeContent = (content: Partial<ChatBotFlowBlockContent>) => {
		setBlockContent(lastState => ({
			...lastState,
			...content
		}))
	}

	return (
		<ActionDialog
			title="SELECIONE O QUE FAZER CASO O CONTATO JÁ EXISTA"
			onSave={handleSave}
			saveText="SALVAR"
			onClose={handleClose}
			openDialog={opened}
			fullWidth
			maxWidth="md"
		>
			<Grid
				container
				spacing={2}
			>
				<Grid
					item
					xs={12}
				>
					<Autocomplete
						defaultValue={chatBotFlowBlockContent.registerContactToActiveCampaignActionOption?.name}
						options={constructionResources.registerContactToActiveCampaignActionOptions}
						getOptionSelected={(option, value) => option.slug === value.slug}
						getOptionLabel={(option) => option.name}
						fullWidth
						filterSelectedOptions
						onChange={(_, option) => {
							if (option) {
								handleChangeContent({
									registerContactToActiveCampaignActionOption: option
								})
							}
						}}
						renderInput={(params) => {
							return (
								<TextField
									className={classes.filterInput}
									variant="outlined"
									placeholder="Selecione um campo personalizado"
									{...({
										...params,
										InputProps: {
											...params.InputProps
										}
									})}
								/>
							)
						}}
						renderTags={(value, getTagProps) => {
							return value.map((attendant, index) => (
								<Chip
									key={index}
									label={attendant.name}
									size="small"
									{...getTagProps({ index })}
								/>
							))
						}
						}
						size="small"
					/>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

ContactAlreadyExistsEditor.open = (props: ContactAlreadyExistsEditorProps) => {
	renderComponent(
		"contact-already-exists-editor",
		<ContactAlreadyExistsEditor
			{...props}
		/>
	)
}

export default ContactAlreadyExistsEditor
